/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * - 予約中: reserved
- 精算待ち: waitingForPayment
- 処方箋送付待ち: waitingForPrescription
- お薬送付待ち: waitingForMedicationShipment
- 完了: complete
- キャンセル : canceled
 */
export type ConsultationModelDTOStatus = typeof ConsultationModelDTOStatus[keyof typeof ConsultationModelDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConsultationModelDTOStatus = {
  reserved: 'reserved',
  waitingForPayment: 'waitingForPayment',
  waitingForPrescription: 'waitingForPrescription',
  waitingForMedicationShipment: 'waitingForMedicationShipment',
  complete: 'complete',
  canceled: 'canceled',
} as const;
